import React, { useEffect, useState } from 'react';
import { Route, Redirect, useHistory } from 'react-router-dom';
import axiosInstance from '../config';
import { toast } from 'react-toastify';

const ProtectedRoute = ({ component: Component, ...rest }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(null);
  const [isLoading, setLoading] = useState(true);
  const [User, setUser] = useState(null);
  const [username, setUsername] = useState('');
  let history = useHistory();

  useEffect(() => {
    axiosInstance
      .get('agent/me')
      .then((res) => {
        setUsername(res.data.username);
        setUser(res.data);
        setIsAuthenticated(true);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        sessionStorage.clear();
        if(err.response.status === 503) {
          /*toast.info("Under Maintenance. Please try again later.", {
            position: "top-right",
            autoClose: 10000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
          });*/
          history.push('/maintenance')
        }

        if(window.location.pathname !== '/') {
          history.push('/');
        }
      });
  }, [history]);

  if (isLoading === true) {
    return (
      <div className="spinner-border" role="status">
        <span className="sr-only">Loading...</span>
      </div>
    );
  }

  return (
    <Route
      {...rest}
      render={(props) =>
        !isAuthenticated ? (
          <Redirect to="/" />
        ) : (
          <Component {...props} User={User} username={username} />
        )
      }
    />
  );
};

export default ProtectedRoute;
